import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icona-fangxiangzhishiyoujiantouyou",
  "use": "icon-icona-fangxiangzhishiyoujiantouyou-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icona-fangxiangzhishiyoujiantouyou\"><path d=\"M699.136 699.136a38.4 38.4 0 11-54.272-54.272L739.2 550.4H192a38.4 38.4 0 010-76.8h547.264l-94.4-94.464a38.4 38.4 0 0154.272-54.272l159.808 159.808a38.528 38.528 0 010 54.656L699.136 699.136z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol